// src/app/seo/seo-universal.resolver.ts
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SeoContentService, ResolvedSeo, ResolvedBridgeSeo } from './seo-content.service';

export type UniversalSeoResolved =
  | { type: 'swap'; resolved: ResolvedSeo }
  | { type: 'bridge'; resolved: ResolvedBridgeSeo };

@Injectable({ providedIn: 'root' })
export class SeoUniversalResolver implements Resolve<UniversalSeoResolved | null> {
  private seo = inject(SeoContentService);
  private translate = inject(TranslateService);

  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    const locale = (route.paramMap.get('locale') || 'en').toLowerCase();
    const slug = (route.paramMap.get('slug') || '').toLowerCase();

    // Synchronise ngx-translate avec la langue de l’URL
    if (this.translate.currentLang !== locale) {
      this.translate.setDefaultLang('en');
      this.translate.use(locale);
    }

    // 1) Variante SWAP
    return this.seo.getSwapSeoBySlug(locale, slug).pipe(
      map((r) => {
        (r as any).locale = locale; // impose la locale du payload
        // ✅ objet littéral avec type précis
        return { type: 'swap', resolved: r } as const as UniversalSeoResolved;
      }),

      // 2) Fallback BRIDGE
      catchError(() =>
        this.seo.getBridgeSeoBySlug(locale, slug).pipe(
          map((r) => {
            (r as any).locale = locale;
            return { type: 'bridge', resolved: r } as const as UniversalSeoResolved;
          }),
          catchError(() => of(null))
        )
      )
    );
  }
}
